// src/utils/navigation.js
let navigateFn;

export const setNavigate = (navFn) => {
  navigateFn = navFn;
};

// In navigation.js
export const navigate = (to) => {
  // console.log("navigate called", { to, navigateFn });
  if (navigateFn) {
    navigateFn(to);
  } else {
    window.location.href = to;
  }
};
